import { GradientColorValue } from '@modules/loaders/interfaces/gradient-color-value.interface';
import { RadialGradientPositionValue } from '@modules/loaders/types/radial-gradient-position-value.type';

export function parseLinearGradient(val: string, loaderSize: { w: number; h: number }) {
  const regex = /linear-gradient\(([0-9a-z,\s#%(.)]+)\)/;
  const matches = val.match(regex);
  if (matches) {
    const valuesRegex = /\S+[(\d\s,.)%]+|[\s\-\w#%]+/gm;
    const colorStops = matches[1].match(valuesRegex);

    if (colorStops) {

      const colors = parseColorStops(colorStops);

      const angle = parseInt(colorStops[0].trim(), 10);

      const linearGradientPosition = getLinearGradientPosition(angle, loaderSize);

      const gradientColorValues = colors.slice(1, colors.length);

      return {
        linearGradientPosition,
        gradientColorValues
      };
    }
  }
  return null;
}

export function parseRadialGradient(val: string) {
  const regex = /radial-gradient\(([a-z\s)|([0-9a-z,#%.]+)\)/;
  const matches = val.match(regex);
  if (matches) {
    const valuesRegex = /(circle[a-z\s]+)|(\S+[(\d\s,.)%]+)|([\s\-\w#%]+)/gm;
    const colorStops = (matches[1].match(valuesRegex) || [])
      .map((v: string) => v.trim())
      .filter(v => v.length > 3);

    if (colorStops) {

      const colors = parseColorStops(colorStops);

      const gradientPosition = colorStops[0].trim().replace(/,$/, '') as RadialGradientPositionValue;

      const radialGradientPosition = {
        x: '50%',
        y: '50%'
      };
      if (gradientPosition.includes('top')) {
        radialGradientPosition.y = '0%';
      }
      if (gradientPosition.includes('bottom')) {
        radialGradientPosition.y = '100%';
      }
      if (gradientPosition.includes('left')) {
        radialGradientPosition.x = '0%';
      }
      if (gradientPosition.includes('right')) {
        radialGradientPosition.x = '100%';
      }
      const gradientColorValues = colors.slice(1, colors.length);

      return {
        gradientColorValues,
        radialGradientPosition
      };
    }
  }

  return null;
}

export function parseColorStops(colorStops): GradientColorValue[] {
  return colorStops.map(stop => {
    stop = stop.trim();
    let color: string;
    let position: number;
    // includes rgba value
    if (stop.includes(') ')) {
      const parts = stop.split(') ');
      position = parseInt(parts[1], 10);
      color = `${parts[0]})`;
    } else {
      const parts = stop.split(' ');
      position = parseInt(parts[1], 10);
      color = parts[0];
    }
    if (position > 100) {
      position = 100;
    }
    if (position < 0) {
      position = 0;
    }
    return {
      color,
      position: `${position}%`,
    };
  });
}

export function getLinearGradientPosition(angle: number, loaderSize: any) {
  const {w, h} = loaderSize;
  if (w === h) {
    if (angle >= 0 && angle < 90) {
      return {
        x1: `${angle / 90 * w}%`,
        y1: '0%',
        x2: `${w}%`,
        y2: `${angle / 90 * h}%`,
      };
    } else if (angle >= 90 && angle < 180) {
      return {
        x1: `${w}%`,
        y1: `${(angle - 90) / 90 * h}%`,
        x2: `${(180 - angle) / 90 * w}%`,
        y2: `${h}%`,
      };
    } else if (angle >= 180 && angle < 270) {
      return {
        x1: `${(270 - angle) / 90 * w}%`,
        y1: `${h}%`,
        x2: `0%`,
        y2: `${(270 - angle) / 90 * h}%`,
      };
    } else {
      return {
        x1: `0%`,
        y1: `${(360 - angle) / 90 * h}%`,
        x2: `${angle / 90 * w}%`,
        y2: `0%`,
      };
    }

  }
  if (angle >= 0 && angle < 90) {
    return {
      x1: `${angle / 90 * w}%`,
      y1: '0%',
      x2: `${w}%`,
      y2: `${angle / 90 * h}%`,
    };
  } else if (angle >= 90 && angle < 180) {
    return {
      x1: `${w}%`,
      y1: `${(angle - 90) / 90 * h}%`,
      x2: `${w - (angle - 90) / 90 * w}%`,
      y2: `${h}%`,
    };
  } else if (angle >= 180 && angle < 270) {
    return {
      x1: `${w - (angle - 180) / 90 * w}%`,
      y1: `${h}%`,
      x2: `0%`,
      y2: `${h - (angle - 180) / 90 * h}%`,
    };
  } else {
    return {
      x1: `0%`,
      y1: `${h - (angle - 270) / 90 * h}%`,
      x2: `${(angle - 270) / 90 * w}%`,
      y2: `0%`,
    };
  }
}
